import { AmendmentType, IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the query parameters for the endpoints available in
 * the `Amendments` endpoint class.
 */
export interface IAmendmentsQueryParameters extends IBaseQueryParameters {
  /** Start timestamp to filter by update date. */
  fromDateTime?: string

  /** End timestamp to filter by update date. */
  toDateTime?: string
}

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Amendments` endpoint class.
 */
export interface IAmendmentPathParameters {
  /** The congress number. For example, the value can be `117`. */
  congress?: number

  /** The type of amendment. Value can be hamdt, samdt, or suamdt. */
  amendmentType?: AmendmentType

  /** The amendments assigned number. For example, the value can be 2137. */
  amendmentNumber?: number
}
